(function () {

    angular
        .module('smartertoolsApp')
        .factory('accountService', ['$q', '$http', 'refreshToken', accountService]);

    function accountService($q, $http, refreshToken) {
        const urlBase = apiRootUrl;
        let promise1;

        const dataFactory = {};
        dataFactory.getAccountSettings = getAccountSettings;
        dataFactory.saveAccountInfo = saveAccountInfo;
        dataFactory.saveLoginEmail = saveLoginEmail;
        dataFactory.saveLoginPassword = saveLoginPassword;
        dataFactory.saveUserLoginPassword = saveUserLoginPassword;
        dataFactory.saveEmailPreferences = saveEmailPreferences;
        dataFactory.saveContact = saveContact;
        dataFactory.deleteContact = deleteContact;
        dataFactory.saveLogin = saveLogin;
        dataFactory.deleteLogin = deleteLogin;
        return dataFactory;

        // -----------------------------------------------

        function getAccountSettings() {
            if (promise1)
                return promise1;
            promise1 = refreshToken.refreshToken()
                .then(() => $http.get(urlBase + 'v1/account/details'))
                .then((response) => {
                    promise1 = null;
                    return response.data;
                });
            return promise1;
        }

        function saveAccountInfo(details) {
            return refreshToken.refreshToken()
                .then(() => $http.post(urlBase + 'v1/account/details/account-info', JSON.stringify(details)))
                .then((response) => response.data);
        }

        function saveLoginEmail(details) {
            return refreshToken.refreshToken()
                .then(() => {
                    details.RefreshToken = localStorage.getItem('stRefreshToken') || sessionStorage.getItem('stRefreshToken');
                    return $http.post(urlBase + 'v1/account/details/change-email', JSON.stringify(details));
                })
                .then((response) => response.data);
        }

        function saveLoginPassword(details) {
            return refreshToken.refreshToken()
                .then(() => {
                    details.RefreshToken = localStorage.getItem('stRefreshToken') || sessionStorage.getItem('stRefreshToken');
                    return $http.post(urlBase + 'v1/account/details/change-password', JSON.stringify(details));
                })
                .then((response) => response.data);
        }

        function saveUserLoginPassword(details) {
            return refreshToken.refreshToken()
                .then(() => {
                    details.RefreshToken = localStorage.getItem('stRefreshToken') || sessionStorage.getItem('stRefreshToken');
                    return $http.post(urlBase + 'v1/account/logins/change-my-password', JSON.stringify(details));
                })
                .then((response) => response.data);
        }

        function saveEmailPreferences(details) {
            return refreshToken.refreshToken()
                .then(() => $http.post(urlBase + 'v1/account/details/email-preferences', JSON.stringify(details)))
                .then((response) => response.data);
        }

        function saveContact(contact) {
            return refreshToken.refreshToken()
                .then(() => {
                    if (contact.ContactId)
                        return $http.post(urlBase + 'v1/account/contacts/update', JSON.stringify(contact));
                    else
                        return $http.post(urlBase + 'v1/account/contacts/add', JSON.stringify(contact));
                })
                .then((response) => response.data);
        }

        function deleteContact(contact) {
            return refreshToken.refreshToken()
                .then(() => {
                    if (contact.ContactId)
                        return $http.delete(urlBase + 'v1/account/contacts/' + contact.ContactId);
                    else
                        $q.reject('Contact does not exist');
                })
                .then((response) => response.data);
        }

        function saveLogin(login) {
            return refreshToken.refreshToken()
                .then(() => {
                    if (login.UserId)
                        return $http.post(urlBase + 'v1/account/logins/update', JSON.stringify(login));
                    else
                        return $http.post(urlBase + 'v1/account/logins/add', JSON.stringify(login));
                })
                .then((response) => response.data);
        }

        function deleteLogin(login) {
            return refreshToken.refreshToken()
                .then(() => {
                    if (login.UserId)
                        return $http.delete(urlBase + 'v1/account/logins/' + login.UserId);
                    else
                        $q.reject('Login does not exist');
                })
                .then((response) => response.data);
        }
    }

})();